import styled from "styled-components";
import { Box } from "@mui/material";

export const EntranceConfigContainer = styled(Box)`
	margin-top: 20px;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 16px;

	.entrance_card {
		border: 2px solid transparent;
		border-radius: 16px;
		padding: 10px;
		cursor: pointer;
		box-shadow: 0 0 1px 1px #d9d9d9;
		transition: border-color 0.2s ease;

		&.selected {
			border-color: #799dbc;
		}
	}

	.preview_frame {
		border-radius: 12px;
		overflow: hidden;
		pointer-events: none;

		/* Modal only: give the envelope breathing room. The live invitation entrance is unchanged. */
		&.envelope .animation_wrapper {
			zoom: 0.78;
		}
	}

	.entrance_footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;

		.label {
			font-family: var(--poppins), sans-serif;
			font-weight: 600;
		}

		.check {
			color: #799dbc;
		}
	}
`;
